import { HugeiconsIcon } from "@hugeicons/react";
import {
  CalendarCheckIn01Icon,
  CalendarCheckOut01Icon,
  CottageIcon,
  GuestHouseIcon,
  Home05Icon,
  PolicyIcon,
  LicenseThirdPartyIcon,
  ServiceIcon,
  ValidationApprovalIcon,
  CheckmarkBadge03Icon,
  StoreVerified01Icon,
  SearchAreaIcon,
  SeoIcon,
  Building03Icon,
  Mosque02Icon,
  ScrollIcon,
  TwinTowerIcon,
  RealEstate01FreeIcons,
  HajiIcon,
  AddSquareFreeIcons,
  AddTeamFreeIcons,
  UserGroup03FreeIcons,
  Alert01FreeIcons,
  WorkAlertFreeIcons,
  SquareArrowUpRightFreeIcons,
  AirplaneTakeOff01Icon,
  Kaaba01FreeIcons,
  Airplane02FreeIcons,
  LicenseIcon,
  ComplaintFreeIcons,
  AnalysisTextLinkFreeIcons,
  SquareArrowDataTransferDiagonalFreeIcons,
  Analytics01FreeIcons,
  Activity03FreeIcons,
  AlertDiamondFreeIcons,
  ManagerFreeIcons,
  UserIdVerificationFreeIcons,
  Location03FreeIcons,
  Settings01FreeIcons,
  SecurityCheckFreeIcons,
  Archive02FreeIcons,
  UserUnlock01Icon,
  DatabaseAddIcon,
  CalendarCheckIn01FreeIcons,
  CalendarCheckOut01FreeIcons,
  QuestionIcon,
} from "@hugeicons/core-free-icons";
import { Briefcase06Icon, ParagraphBulletsPoint02Icon } from "@hugeicons/core-free-icons/index";

export const Home = function () {
  return <HugeiconsIcon icon={Home05Icon} />;
};

// ----- Planning and Preparation -----
export const ServiceHugeIcon = function () {
  return <HugeiconsIcon icon={ServiceIcon} />;
};

export const ValidationApprovalHugeIcon = function () {
  return <HugeiconsIcon icon={ValidationApprovalIcon} />;
};

export const GuestHouseHugeIcon = function () {
  return <HugeiconsIcon icon={GuestHouseIcon} />;
};
export const CampaignsHugeIcon = function () {
  return <HugeiconsIcon icon={CalendarCheckIn01FreeIcons} />;
};
export const GroupsHugeIcon = function () {
  return <HugeiconsIcon icon={CalendarCheckOut01FreeIcons} />;
};
export const QuestionHugeIcon = function () {
  return <HugeiconsIcon icon={QuestionIcon} />;
};
export const CalendarCheckInHugeIcon = function () {
  return <HugeiconsIcon icon={CalendarCheckIn01Icon} />;
};

export const CalendarCheckOutHugeIcon = function () {
  return <HugeiconsIcon icon={CalendarCheckOut01Icon} />;
};

export const CottageHugeIcon = function () {
  return <HugeiconsIcon icon={CottageIcon} />;
};

export const PolicyHugeIcon = function () {
  return <HugeiconsIcon icon={PolicyIcon} />;
};

// ----- Reception -----
export const RealEstateHugeIcon = function () {
  return <HugeiconsIcon icon={RealEstate01FreeIcons} />;
};

export const MosqueHugeIcon = function () {
  return <HugeiconsIcon icon={Mosque02Icon} />;
};

export const Briefcase06HugeIcon = function () {
  return <HugeiconsIcon icon={Briefcase06Icon} />;
};

export const TwinTowerHugeIcon = function () {
  return <HugeiconsIcon icon={TwinTowerIcon} />;
};

// ----- Housing and Accommodations -----

export const LicenseThirdPartyHugeIcon = function () {
  return <HugeiconsIcon icon={LicenseThirdPartyIcon} />;
};

export const ScrollHugeIcon = function () {
  return <HugeiconsIcon icon={ScrollIcon} />;
};

export const CheckmarkBadgeHugeIcon = function () {
  return <HugeiconsIcon icon={CheckmarkBadge03Icon} />;
};

export const StoreVerifiedHugeIcon = function () {
  return <HugeiconsIcon icon={StoreVerified01Icon} />;
};

export const SearchAreaHugeIcon = function () {
  return <HugeiconsIcon icon={SearchAreaIcon} />;
};

export const SeoHugeIcon = function () {
  return <HugeiconsIcon icon={SeoIcon} />;
};

export const Building03HugeIcon = function () {
  return <HugeiconsIcon icon={Building03Icon} />;
};
export const ParagraphBulletsPoint02HugeIcon = function () {
  return <HugeiconsIcon icon={ParagraphBulletsPoint02Icon} />;
};

// ----- Pilgrims and Groups -----
export const HajjHugeIcon = function () {
  return <HugeiconsIcon icon={HajiIcon} />;
};

export const AddSquareHugeIcon = function () {
  return <HugeiconsIcon icon={AddSquareFreeIcons} />;
};

export const AddTeamHugeIcon = function () {
  return <HugeiconsIcon icon={AddTeamFreeIcons} />;
};

export const UserGroup03HugeIcon = function () {
  return <HugeiconsIcon icon={UserGroup03FreeIcons} />;
};

// ----- Reports and Incidents -----
export const Alert01HugeIcon = function () {
  return <HugeiconsIcon icon={Alert01FreeIcons} />;
};

export const WorkAlertHugeIcon = function () {
  return <HugeiconsIcon icon={WorkAlertFreeIcons} />;
};

// ----- Departure -----
export const SquareArrowUpRightHugeIcon = function () {
  return <HugeiconsIcon icon={SquareArrowUpRightFreeIcons} />;
};

export const AirplaneTakeOff01HugeIcon = function () {
  return <HugeiconsIcon icon={AirplaneTakeOff01Icon} />;
};

export const Kaaba01HugeIcon = function () {
  return <HugeiconsIcon icon={Kaaba01FreeIcons} />;
};

export const Airplane02HugeIcon = function () {
  return <HugeiconsIcon icon={Airplane02FreeIcons} />;
};

export const LicenseHugeIcon = function () {
  return <HugeiconsIcon icon={LicenseIcon} />;
};

// ----- Reports and Statistics -----

export const ComplaintHugeIcon = function () {
  return <HugeiconsIcon icon={ComplaintFreeIcons} />;
};

export const AnalysisTextLinkHugeIcon = function () {
  return <HugeiconsIcon icon={AnalysisTextLinkFreeIcons} />;
};

export const SquareArrowDataTransferDiagonalHugeIcon = function () {
  return <HugeiconsIcon icon={SquareArrowDataTransferDiagonalFreeIcons} />;
};

export const Analytics01HugeIcon = function () {
  return <HugeiconsIcon icon={Analytics01FreeIcons} />;
};

export const Activity03HugeIcon = function () {
  return <HugeiconsIcon icon={Activity03FreeIcons} />;
};

export const AlertDiamondHugeIcon = function () {
  return <HugeiconsIcon icon={AlertDiamondFreeIcons} />;
};

export const ManagerHugeIcon = function () {
  return <HugeiconsIcon icon={ManagerFreeIcons} />;
};

export const UserIdVerificationHugeIcon = function () {
  return <HugeiconsIcon icon={UserIdVerificationFreeIcons} />;
};

// ----- System Management -----
export const Location03HugeIcon = function () {
  return <HugeiconsIcon icon={Location03FreeIcons} />;
};

export const Settings01HugeIcon = function () {
  return <HugeiconsIcon icon={Settings01FreeIcons} />;
};

export const SecurityCheckHugeIcon = function () {
  return <HugeiconsIcon icon={SecurityCheckFreeIcons} />;
};

// ----- Archives -----
export const Archive02HugeIcon = function () {
  return <HugeiconsIcon icon={Archive02FreeIcons} />;
};
export const UserUnlock01HugeIcon = function () {
  return <HugeiconsIcon icon={UserUnlock01Icon} />;
};
export const DatabaseAddHugeIcon = function () {
  return <HugeiconsIcon icon={DatabaseAddIcon} />;
};
